
// Seasons

import { SeasonID } from "../models/common"

const Season_1_ID = ("cd1b6714-f4de-4dfc-a030-851b3459d8d1") as SeasonID
const Season_2_ID = ("7af53acf-1fb9-40e8-96c7-ab8308a353f9") as SeasonID

interface seasonData {
    id: SeasonID,
    num: number
}
export const All_Seasons: seasonData[] = [
    {
        id: Season_1_ID,
        num: 1
    },
    {
        id: Season_2_ID,
        num: 2
    }
]